import { useQuery, useQueryClient } from "@tanstack/react-query";
import * as React from "react";
import { Category, CategoryServices } from "@/services/bedrock";
import { FilterType } from "@/interfaces";

export const useNewCategories = (
  type: "LIBRARY" | "CAMPAIGN" | "VIDEO_SCRIPT" | "SUPER_PAGE",
  globalOnly: boolean | undefined = undefined
) => {
  const queryClient = useQueryClient();
  const { data: categories = [], isFetching } = useQuery({
    queryKey: ["categories", type, globalOnly],
    queryFn: () =>
      CategoryServices.getCategories({
        type,
        globalOnly,
        excludeUnusedCategories: true,
        perPage: 100,
        sort: "name",
      }).then(r => r.content),
    initialData: [],
  });

  const categoriesToFilter = (result: Category[]): FilterType[] => {
    return result.map((category, index) => {
      return {
        key: index,
        text: category.name || "",
        value: category.id || "",
      } as FilterType;
    });
  };

  const categoryOptions = React.useMemo(() => {
    return categoriesToFilter(categories);
  }, [categories]);

  const clearCategoryCache = () => {
    queryClient.invalidateQueries({ queryKey: ["categories", type] }).catch(console.error);
  };

  return { categories, categoryOptions, clearCategoryCache, isFetching };
};
